import React from "react";
import {
  faCalendarCheck,
  faChampagneGlasses,
  faCogs,
  faLocationDot,
  faPercent,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getRuta } from "../../helpers/Helpers";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { GrupoNav, ItemNav } from "./ItemNav";

export const Configurations = ({ drawerIsOpen }) => {
  let rout = getRuta();
  return (
    <GrupoNav
      icono={<FontAwesomeIcon icon={faCogs} fixedWidth />}
      texto="Configuraciones"
      drawerIsOpen={drawerIsOpen}
    >
      <ItemNav
        to={`${rout}/locations`}
        icono={<FontAwesomeIcon icon={faLocationDot} fixedWidth />}
        texto="Ubicaciones"
        drawerIsOpen={drawerIsOpen}
      />

      <ItemNav
        to={`${rout}/tasa-interes`}
        icono={<FontAwesomeIcon icon={faPercent} fixedWidth />}
        texto="Tasa de Interés"
        drawerIsOpen={drawerIsOpen}
      />

      <ItemNav
        to={`${rout}/periodicidad`}
        icono={<FontAwesomeIcon icon={faCalendarCheck} fixedWidth />}
        texto="Periodicidad"
        drawerIsOpen={drawerIsOpen}
      />

      <ItemNav
        to={`${rout}/holidays`}
        icono={<FontAwesomeIcon icon={faChampagneGlasses} fixedWidth />}
        texto="Días Festivos"
        drawerIsOpen={drawerIsOpen}
      />

      <ItemNav
        to={`${rout}/tasa-cambio`}
        icono={<CurrencyExchangeIcon />}
        texto="Tasa de Cambio"
        drawerIsOpen={drawerIsOpen}
      />
    </GrupoNav>
  );
};
